import React from 'react';
import { ImageViewType } from '../../../../constants/enums';
import { IConfigurableCar, IStockCar } from '../../../../interfaces/Car';

export const getImageUrl = (carDetails: IConfigurableCar | IStockCar) => {
    return carDetails.images.find(image => image.type === ImageViewType.EXTERIOR).url;
};

export const renderImage = (url: string) => {
    return (
        <div className="car-preview">
            <img src={url} />
        </div>
    );
};
